const getWebpackManifest = host => {
	const manifestUrl = `${host}/manifest.json`;

	return fetch(manifestUrl, { mode: 'cors' }).then(data => {
		if (!data.ok) {
			throw new Error();
		}

		return data.json();
	});
};

export default getWebpackManifest;
